import { useContext } from "react"
import { useMutation } from "react-query"
import AuthContext from "../Context/auth_provider.jsx"
import useAxiosPrivate from "./useAxiosPrivate.js"

const useSSOUsers = () => {
    const { companyId, teamId } = useContext(AuthContext)
    const domain = teamId ? `/team/${teamId}` : `/corporate/${companyId}`
    const axiosPrivate = useAxiosPrivate()

    return useMutation((phone) =>
        axiosPrivate
            .post(`${domain}/users/phone`, phone)
            .then((res) => res.data)
    )
}

export default useSSOUsers
